import { fetchApi } from "./fetchApi";

export default {
  async importUserListByServiceArea(serviceAreaId) {
    const response = await fetchApi({
      method: "get",
      url: `/api/userImport/${serviceAreaId}`,
    });

    return response.data.result;
  },
};
